<template>
  <div>
    <div class="row">
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div class="form-group">
          <label for="numeroDocuemnto"
            >30 - Código na operadora / CNPJ / CPF</label
          >
          <div class="input-group">
            <div class="input-group-addon">
              <span
                type="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >{{ nomeDocumento(guia.contratadoExecutante.tipoExecutante) }}
                <span class="caret"
              /></span>
              <ul class="dropdown-menu">
                <li
                  :class="{
                    active: guia.contratadoExecutante.tipoExecutante === 'C',
                  }"
                >
                  <a
                    data-test-id="a-alterartipo-1"
                    href="#"
                    @click.prevent="alterarTipo('C')"
                    >Cód. na operadora</a
                  >
                </li>
                <li
                  :class="{
                    active: guia.contratadoExecutante.tipoExecutante === 'F',
                  }"
                >
                  <a
                    data-test-id="a-alterartipo-2"
                    href="#"
                    @click.prevent="alterarTipo('F')"
                    >CPF</a
                  >
                </li>
                <li
                  :class="{
                    active: guia.contratadoExecutante.tipoExecutante === 'J',
                  }"
                >
                  <a
                    data-test-id="a-alterartipo-3"
                    href="#"
                    @click.prevent="alterarTipo('J')"
                    >CNPJ</a
                  >
                </li>
              </ul>
            </div>
            <input
              v-if="guia.contratadoExecutante.tipoExecutante === 'C'"
              id="documentoExecutante"
              v-model="guia.contratadoExecutante.documentoExecutante"
              data-test-id="input-documentoexecutante-codigo"
              type="text"
              name="documentoExecutante"
              class="form-control"
              placeholder="Código na operadora do contratado solicitante"
            />
            <input
              v-if="guia.contratadoExecutante.tipoExecutante === 'F'"
              id="documentoExecutante"
              v-model="guia.contratadoExecutante.documentoExecutante"
              v-mask="'999.999.999-99'"
              data-test-id="input-documentoexecutante-cpf"
              type="text"
              name="documentoExecutante"
              class="form-control"
              placeholder="CPF do contratado solicitante"
            />
            <input
              v-if="guia.contratadoExecutante.tipoExecutante === 'J'"
              id="documentoExecutante"
              v-model="guia.contratadoExecutante.documentoExecutante"
              v-mask="'99.999.999/9999-99'"
              data-test-id="input-documentoexecutante-cnpj"
              type="text"
              name="documentoExecutante"
              class="form-control"
              placeholder="CNPJ do contratado solicitante"
            />
          </div>
        </div>
      </div>
      <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7">
        <div
          :class="{
            'has-error': validations.guia.contratadoExecutante.nome.$error,
          }"
          class="form-group"
        >
          <label for="nome">31 - Nome do contratado </label>
          <input
            id="nome"
            v-model="guia.contratadoExecutante.nome"
            data-test-id="input-nome"
            type="text"
            name="nome"
            class="form-control"
            placeholder="Nome do contratado"
            @input="validations.guia.contratadoExecutante.nome.$touch()"
          />
          <span v-if="validations.guia.contratadoExecutante.nome.$dirty">
            <span
              v-if="!validations.guia.contratadoExecutante.nome.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.contratadoExecutante.nome.$params.maxLength.max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div
          :class="{
            'has-error': validations.guia.contratadoExecutante.cnes.$error,
          }"
          class="form-group"
        >
          <label for="cnes">40 - Código CNES</label>
          <input
            id="cnes"
            v-model="guia.contratadoExecutante.cnes"
            data-test-id="input-cnes"
            type="text"
            name="cnes"
            class="form-control"
            placeholder="Código CNES do contratado solicitante"
          />
          <span v-if="validations.guia.contratadoExecutante.cnes.$dirty">
            <span
              v-if="!validations.guia.contratadoExecutante.cnes.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.contratadoExecutante.cnes.$params.maxLength.max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div
          id="accordionExec"
          class="panel-group"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div id="headingEndereco" class="panel-heading" role="tab">
              <h4 class="panel-title">
                <a
                  data-test-id="a-auto-9"
                  role="button"
                  data-toggle="collapse"
                  data-parent="#accordionExec"
                  href="#collapseEndereco"
                  aria-expanded="true"
                  aria-controls="collapseEndereco"
                >
                  Endereço
                </a>
              </h4>
            </div>
            <div
              id="collapseEndereco"
              class="panel-collapse collapse"
              role="tabpanel"
              aria-labelledby="headingEndereco"
            >
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div class="form-group">
                      <label for="tipoLogradouro">32 - Tipo logradouro</label>
                      <select
                        v-model="
                          guia.contratadoExecutante.endereco.tipoLogradouro
                        "
                        data-test-id="select-guia-contratadoexecutante-endereco-tipologradouro"
                        class="form-control"
                      >
                        <option disabled value="">Selecione</option>
                        <option
                          v-for="tipo in tiposLogradouro"
                          :key="tipo.codigo"
                          :value="tipo.codigo"
                          >{{ tipo.codigo }} - {{ tipo.valor }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.endereco
                            .logradouro.$error,
                      }"
                      class="form-group"
                    >
                      <label for="logradouro">33 - Logradouro</label>
                      <input
                        id="logradouro"
                        v-model="guia.contratadoExecutante.endereco.logradouro"
                        data-test-id="input-logradouro"
                        type="text"
                        name="logradouro"
                        class="form-control"
                        placeholder="Nome do logradouro"
                      />
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.endereco
                            .logradouro.$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.endereco
                              .logradouro.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante.endereco
                              .logradouro.$params.maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.endereco.numero
                            .$error,
                      }"
                      class="form-group"
                    >
                      <label for="numero">34 - Número</label>
                      <input
                        id="numero"
                        v-model="guia.contratadoExecutante.endereco.numero"
                        data-test-id="input-numero"
                        type="text"
                        name="numero"
                        class="form-control"
                        placeholder="Número do endereço do contratado executante"
                      />
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.endereco.numero
                            .$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.endereco
                              .numero.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante.endereco
                              .numero.$params.maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.endereco
                            .complemento.$error,
                      }"
                      class="form-group"
                    >
                      <label for="complemento">35 - Complemento</label>
                      <input
                        id="complemento"
                        v-model="guia.contratadoExecutante.endereco.complemento"
                        data-test-id="input-complemento"
                        type="text"
                        name="complemento"
                        class="form-control"
                        placeholder="Complemento do endereço do contratado executante"
                      />
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.endereco
                            .complemento.$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.endereco
                              .complemento.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante.endereco
                              .complemento.$params.maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.endereco
                            .municipio.$error,
                      }"
                      class="form-group"
                    >
                      <label for="municipio">36 - Munícipio</label>
                      <input
                        id="municipio"
                        v-model="guia.contratadoExecutante.endereco.municipio"
                        data-test-id="input-municipio"
                        type="text"
                        name="municipio"
                        class="form-control"
                        placeholder="Município do endereço do contratado executante"
                      />
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.endereco
                            .municipio.$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.endereco
                              .municipio.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante.endereco
                              .municipio.$params.maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div class="form-group">
                      <label for="uf">37 - UF</label>
                      <select
                        id="uf"
                        v-model="guia.contratadoExecutante.endereco.uf"
                        data-test-id="select-uf"
                        name="uf"
                        class="form-control"
                      >
                        <option disabled value="">Selecione</option>
                        <option
                          v-for="uf in ufs"
                          :key="uf.sigla"
                          :value="uf.sigla"
                          >{{ uf.sigla }}</option
                        >
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.endereco
                            .codigoIBGEMunicipio.$error,
                      }"
                      class="form-group"
                    >
                      <label for="codigoIBGEMunicipio"
                        >38 - Código IBGE do município</label
                      >
                      <input
                        id="codigoIBGEMunicipio"
                        v-model="
                          guia.contratadoExecutante.endereco.codigoIBGEMunicipio
                        "
                        data-test-id="input-codigoibgemunicipio"
                        type="text"
                        name="codigoIBGEMunicipio"
                        class="form-control"
                        placeholder="Código IBGE do município do contratado executante"
                      />
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.endereco
                            .codigoIBGEMunicipio.$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.endereco
                              .codigoIBGEMunicipio.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante.endereco
                              .codigoIBGEMunicipio.$params.maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div class="form-group">
                      <label for="cep">39 - CEP</label>
                      <input
                        id="cep"
                        v-model="guia.contratadoExecutante.endereco.cep"
                        v-mask="'99999-999'"
                        data-test-id="input-cep"
                        type="text"
                        name="cep"
                        class="form-control"
                        placeholder="CEP de residência do contratado executante"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div id="headingExecComp" class="panel-heading" role="tab">
              <h4 class="panel-title">
                <a
                  data-test-id="a-auto-18"
                  role="button"
                  data-toggle="collapse"
                  data-parent="#accordionExec"
                  href="#collapseExecComp"
                  aria-expanded="true"
                  aria-controls="collapseExecComp"
                >
                  Executante complementar
                </a>
              </h4>
            </div>
            <div
              id="collapseExecComp"
              class="panel-collapse collapse"
              role="tabpanel"
              aria-labelledby="headingWExecComp"
            >
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                    <div class="form-group">
                      <label for="documentoComplementar"
                        >40a - Código na operadora / CNPJ / CPF do exec.
                        complementar</label
                      >
                      <div class="input-group">
                        <div class="input-group-addon">
                          <span
                            type="button"
                            class="dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            >{{
                              nomeDocumento(
                                guia.contratadoExecutante.tipoComplementar
                              )
                            }}
                            <span class="caret"
                          /></span>
                          <ul class="dropdown-menu">
                            <li
                              :class="{
                                active:
                                  guia.contratadoExecutante.tipoComplementar ===
                                  'C',
                              }"
                            >
                              <a
                                data-test-id="a-alterartipocomplementar-19"
                                href="#"
                                @click.prevent="alterarTipoComplementar('C')"
                                >Cód. na operadora</a
                              >
                            </li>
                            <li
                              :class="{
                                active:
                                  guia.contratadoExecutante.tipoComplementar ===
                                  'F',
                              }"
                            >
                              <a
                                data-test-id="a-alterartipocomplementar-20"
                                href="#"
                                @click.prevent="alterarTipoComplementar('F')"
                                >CPF</a
                              >
                            </li>
                            <li
                              :class="{
                                active:
                                  guia.contratadoExecutante.tipoComplementar ===
                                  'J',
                              }"
                            >
                              <a
                                data-test-id="a-alterartipocomplementar-21"
                                href="#"
                                @click.prevent="alterarTipoComplementar('J')"
                                >CNPJ</a
                              >
                            </li>
                          </ul>
                        </div>
                        <input
                          v-if="
                            guia.contratadoExecutante.tipoComplementar === 'C'
                          "
                          id="documentoComplementar"
                          v-model="
                            guia.contratadoExecutante.documentoComplementar
                          "
                          data-test-id="input-documentocomplementar-codigo"
                          type="text"
                          name="documentoComplementar"
                          class="form-control"
                          placeholder="Código na operadora do profissional executante/complementar"
                        />
                        <input
                          v-if="
                            guia.contratadoExecutante.tipoComplementar === 'F'
                          "
                          id="documentoComplementar"
                          v-model="
                            guia.contratadoExecutante.documentoComplementar
                          "
                          v-mask="'999.999.999-99'"
                          data-test-id="input-documentocomplementar-cpf"
                          type="text"
                          name="documentoComplementar"
                          class="form-control"
                          placeholder="CPF do profissional executante/complementar"
                        />
                        <input
                          v-if="
                            guia.contratadoExecutante.tipoComplementar === 'J'
                          "
                          id="documentoComplementar"
                          v-model="
                            guia.contratadoExecutante.documentoComplementar
                          "
                          v-mask="'99.999.999/9999-99'"
                          data-test-id="input-documentocomplementar-cnpj"
                          type="text"
                          name="documentoComplementar"
                          class="form-control"
                          placeholder="CNPJ do profissional executante/complementar"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
                    <div class="form-group">
                      <div
                        :class="{
                          'has-error':
                            validations.guia.contratadoExecutante
                              .nomeComplementar.$error,
                        }"
                        class="form-group"
                      >
                        <label for="nomeComplementar"
                          >41 - Nome do profissional executante / complementar
                        </label>
                        <input
                          id="nomeComplementar"
                          v-model="guia.contratadoExecutante.nomeComplementar"
                          data-test-id="input-nomecomplementar"
                          type="text"
                          name="nomeComplementar"
                          class="form-control"
                          placeholder="Nome do profissional executante/complementar"
                        />
                        <span
                          v-if="
                            validations.guia.contratadoExecutante
                              .nomeComplementar.$dirty
                          "
                        >
                          <span
                            v-if="
                              !validations.guia.contratadoExecutante
                                .nomeComplementar.maxLength
                            "
                            class="help-block"
                            >Campo deve ter no máximo
                            {{
                              validations.guia.contratadoExecutante
                                .nomeComplementar.$params.maxLength.max
                            }}
                            caracteres.</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.conselho.$error,
                      }"
                      class="form-group"
                    >
                      <label for="conselho"
                        >42 - Conselho profissional <sup>(3)</sup></label
                      >
                      <select
                        id="conselho"
                        v-model="guia.contratadoExecutante.conselho"
                        data-test-id="select-conselho"
                        name="conselho"
                        class="form-control"
                      >
                        <option disabled value="">Selecione</option>
                        <option
                          v-for="conselho in conselhos"
                          :key="conselho._id"
                          :value="conselho.sigla"
                          >{{ conselho.codigo }} - {{ conselho.valor }}</option
                        >
                      </select>
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.conselho.$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.conselho
                              .required
                          "
                          class="help-block"
                          >Campo obrigatório.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.conselhoNumero
                            .$error,
                      }"
                      class="form-group"
                    >
                      <label for="conselhoNumero"
                        >43 - Número no conselho <sup>(3)</sup></label
                      >
                      <input
                        id="numeroConselho"
                        v-model="guia.contratadoExecutante.conselhoNumero"
                        data-test-id="input-numeroconselho"
                        type="text"
                        name="numeroConselho"
                        class="form-control"
                        placeholder="Número no conselho profissional"
                      />
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.conselhoNumero
                            .$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante
                              .conselhoNumero.required
                          "
                          class="help-block"
                          >Campo obrigatório.</span
                        >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante
                              .conselhoNumero.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante.conselhoNumero
                              .$params.maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.conselhoUF
                            .$error,
                      }"
                      class="form-group"
                    >
                      <label for="conselhoUF"
                        >44 - UF conselho <sup>(3)</sup></label
                      >
                      <select
                        id="conselhoUF"
                        v-model="guia.contratadoExecutante.conselhoUF"
                        data-test-id="select-conselhouf"
                        name="conselhoUF"
                        class="form-control"
                      >
                        <option disabled value="">Selecione</option>
                        <option
                          v-for="uf in ufs"
                          :key="uf.sigla"
                          :value="uf.sigla"
                          >{{ uf.sigla }}</option
                        >
                      </select>
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.conselhoUF
                            .$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.conselhoUF
                              .required
                          "
                          class="help-block"
                          >Campo obrigatório.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.cbo.$error,
                      }"
                      class="form-group"
                    >
                      <label for="cbo">45 - Código CBO-S</label>
                      <select
                        id="cbo"
                        v-model="guia.contratadoExecutante.cbo"
                        data-test-id="select-cbo"
                        name="cbo"
                        class="form-control"
                      >
                        <option disabled value="">Selecione</option>
                        <option
                          v-for="cbo in cbos"
                          :key="cbo.codigo"
                          :value="cbo.codigo"
                          >{{ cbo.codigo }} - {{ cbo.valor }}</option
                        >
                      </select>
                      <span
                        v-if="validations.guia.contratadoExecutante.cbo.$dirty"
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante.cbo.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante.cbo.$params
                              .maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                  <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                    <div
                      :class="{
                        'has-error':
                          validations.guia.contratadoExecutante.grauParticipacao
                            .$error,
                      }"
                      class="form-group"
                    >
                      <label for="grauParticipacao"
                        >45a - Grau de participação</label
                      >
                      <input
                        id="grauParticipacao"
                        v-model="guia.contratadoExecutante.grauParticipacao"
                        v-mask="'99'"
                        data-test-id="input-grauparticipacao"
                        type="text"
                        name="grauParticipacao"
                        class="form-control"
                        placeholder="Grau de participação do profissional na equipe médica de acordo com a tabela de domínio"
                      />
                      <span
                        v-if="
                          validations.guia.contratadoExecutante.grauParticipacao
                            .$dirty
                        "
                      >
                        <span
                          v-if="
                            !validations.guia.contratadoExecutante
                              .grauParticipacao.maxLength
                          "
                          class="help-block"
                          >Campo deve ter no máximo
                          {{
                            validations.guia.contratadoExecutante
                              .grauParticipacao.$params.maxLength.max
                          }}
                          caracteres.</span
                        >
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import { dominioMixin } from '@/mixins/DominioMixin'
import EstadoServico from '@/servicos/EstadoServico'

const estadoServico = new EstadoServico()

export default {
  name: 'DadosContratadoExecutante',
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  props: {
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      conselhos: [],
      ufs: [],
      tiposLogradouro: [],
      cbos: [],
      mostrarEndereco: false,
      mostrarExecutante: false,
    }
  },
  mounted() {
    this.recuperarValoresDominio('cbo').then((res) => {
      this.cbos = res.valores
    })
    this.recuperarValoresDominio('ConselhoProfissional').then((res) => {
      this.conselhos = res.valores
    })
    this.recuperarValoresDominio('TipoLogradouro').then((res) => {
      this.tiposLogradouro = res.valores
    })
    estadoServico.recuperarUfs().then((res) => {
      this.ufs = res.estados
    })
  },
  methods: {
    nomeDocumento(tipo) {
      if (tipo === 'F') {
        return 'CPF'
      } else if (tipo === 'J') {
        return 'CNPJ'
      } else if (tipo === 'C') {
        return 'Cód. na operadora'
      }
    },
    alterarTipo(tipo) {
      this.guia.contratadoExecutante.tipoExecutante = tipo
      this.guia.contratadoExecutante.documentoExecutante = ''
    },
    alterarTipoComplementar(tipo) {
      this.guia.contratadoExecutante.tipoComplementar = tipo
      this.guia.contratadoExecutante.documentoComplementar = ''
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
  },
}
</script>
